<template>
  <div>
    <loadingCube v-if="!loaded && ($store.state.auth.me.roles.includes('client_sub') || $store.state.auth.me.roles.includes('client_auth'))"
                 :loadingMessage="'DASHBOARD'"></loadingCube>
    <div class="dashboard" v-if="loaded && ($store.state.auth.me.roles.includes('client_sub') || $store.state.auth.me.roles.includes('client_auth'))">

      <div class="widget" v-if="isPayrollEnabled && isPayroll">
        <div class="row">
          <div class="col-xl-6">
            <h3>
              <i class="fas fa-check"></i>
              Compliance Score
            </h3>

            <score-widget :text="complinaceLabel" :score="complianceScore"></score-widget>
          </div>
          <div class="col-xl-6">
            <h3>
              <i class="fas fa-hard-hat"></i>
              Uncompliant Workers
            </h3>

            <ul class="scroll-list">
              <li v-for="worker in uncompliantWorkers"><i class="fas fa-exclamation-circle"></i> {{ worker.first_name }} {{ worker.surname }}</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row payment-times-table" v-if="isPayroll">
        <div class="col-xl-12">
          <div class="widget">
            <h3>
              <i class="fas fa-coins"></i>
              Worker Payment Deadlines
            </h3>
            <table class="">
              <thead>
              <tr>
                <th scope="col">Worker Payment Days</th>
                <th scope="col">Submission Of Timesheet / Additions</th>
                <th scope="col">Payment For Invoice To Be Received By</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <th>Monday&nbsp;Midnight (Monday text)</th>
                <td>3:00 PM</td>
                <td>4:00 PM</td>
              </tr>
              <tr>
                <th>Tuesday&nbsp;Midnight (Tuesday text)</th>
                <td>3:00 PM</td>
                <td>4:00 PM</td>
              </tr>
              <tr>
                <th>Wednesday&nbsp;Midnight (Wednesday text)</th>
                <td>3:00 PM</td>
                <td>4:00 PM</td>
              </tr>
              <tr>
                <th>Thursday&nbsp;Midnight Group 1 (Wednesday text)</th>
                <td>3:00 PM</td>
                <td>4:00 PM</td>
              </tr>
              <tr>
                <th>Thursday&nbsp;Midnight Group 2 (Thursday text)</th>
                <td>3:00 PM</td>
                <td>4:00 PM</td>
              </tr>
              <tr>
                <th>Friday&nbsp;11:00 AM (Thursday text)</th>
                <td>9:00 AM</td>
                <td>10:00 AM</td>
              </tr>
              <tr>
                <th>Friday&nbsp;4:30 PM Group 1 (Thursday text)</th>
                <td>2:30 PM</td>
                <td>3:30 PM</td>
              </tr>
              <tr>
                <th>Friday&nbsp;4:30 PM Group 2 (Wednesday text)</th>
                <td>2:30 PM</td>
                <td>3:30 PM</td>
              </tr>
              <tr>
                <th>Friday&nbsp;4:30 PM Group 3 (Friday text)</th>
                <td>2:30 PM</td>
                <td>3:30 PM</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row payment-times-table" v-else-if="isRecruitment">
        <div class="col-xl-12">
          <div class="widget">
            <h3>
              <i class="fas fa-coins"></i>
              Worker Payment Deadlines
            </h3>
            <table>
              <thead>
              <tr>
                <th>Worker Payment Days</th>
                <th>Submission of Timesheet</th>
                <th>Submission of Additions</th>
                <th>Payment For Invoice To Be Received By</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <th scope="row">Thursday</th>
                <td>COB Tuesday</td>
                <td>2:00 PM Thursday</td>
                <td>3:00 PM Thursday</td>
              </tr>
              <tr>
                <th scope="row">Friday 11:00 AM</th>
                <td>COB Tuesday</td>
                <td>9:00 AM Friday</td>
                <td>9:30 AM Friday</td>
              </tr>
              <tr>
                <th scope="row">Friday 4:30 PM</th>
                <td>COB Tuesday</td>
                <td>2:00 PM Friday</td>
                <td>2:30 PM Friday</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-6">
          <div class="widget">
            <h3>
              <i class="fas fa-coins"></i>
              Labour &amp; Expenses Analysis
            </h3>
            <apexchart width="100%" type="area" :options="labourAndExpensesOptions" :series="labourAndExpensesSeries"></apexchart>
          </div>
        </div>
        <div class="col-xl-6">
          <div class="widget">
            <h3>
              <i class="fas fa-map-marker-alt"></i>
              Workers On-Site
            </h3>
            <apexchart width="100%" type="area" :options="workersOnSiteOptions" :series="workersOnSiteSeries"></apexchart>
          </div>
        </div>
      </div>
      <div class="row" v-if="isPayrollEnabled">
        <div class="col-xl-4">
          <div class="widget">
            <h3>
              <i class="fas fa-user"></i>
              Labour Costs
            </h3>
            <table class="list">
              <thead>
              <tr>
                <th>Site</th>
                <th class="text-right">Total Labour Cost</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="data in labourCostsTable">
                <td>{{ data.site }}</td>
                <td class="text-right"><strong>{{ data.amount | currency }}</strong></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-xl-4">
          <div class="widget">
            <h3>
              <i class="fas fa-wrench"></i>
              Material Costs
            </h3>
            <table class="list">
              <thead>
              <tr>
                <th>Site</th>
                <th class="text-right">Total Material Cost</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="data in materialCostsTable">
                <td>{{ data.site }}</td>
                <td class="text-right"><strong>{{ data.amount | currency }}</strong></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-xl-4">
          <div class="widget">
            <h3>
              <i class="fas fa-file-invoice"></i>
              Expenses
            </h3>
            <table class="list">
              <thead>
              <tr>
                <th>Site</th>
                <th class="text-right">Total Expenses</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="data in expensesTable">
                <td>{{ data.site }}</td>
                <td class="text-right"><strong>{{ data.amount | currency }}</strong></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>

<!--    <div class="dashboard">-->
<!--      <button class="btn orcaBtn" @click.prevent="test()">test</button>-->
<!--    </div>-->
  </div>
</template>
<style lang="scss" scoped>

div.payment-times-table{
  table { border-collapse: collapse; width: 100%; }
  caption { font-weight: 700; text-align: left; padding: 0.5rem 0; }
  th, td { border: 1px solid #ccc; padding: 0.5rem; vertical-align: top; }
  th { text-align: left; }
}

</style>
<script>
import VueApexCharts from 'vue-apexcharts'
import Vue from 'vue';
import ScoreWidget from "../layouts/widgets/ScoreWidget";
import loadingCube from "loaders/record_loader";

Vue.use(VueApexCharts)

export default {
  name: "Dashboard",
  components: {
    apexchart: VueApexCharts,
    ScoreWidget: ScoreWidget,
    loadingCube
  },
  data() {
    return {
      loaded: false,

      companyId: null,

      complianceScore: 0,
      complinaceLabel: '0%',
      uncompliantWorkers: [],

      labourAndExpensesOptions: null,
      labourAndExpensesSeries: null,

      workersOnSiteOptions: null,
      workersOnSiteSeries: null,

      labourCostsTable: null,
      materialCostsTable: null,
      expensesTable: null,

      // Flags
      isPayroll: false,
      isRecruitment: false,
      isPayrollEnabled: false,
      isRecruitmentEnabled: false
    }
  },
  created() {
    this.setFlags();
    if (this.$store.state.auth.me.contact_id !== null) {
      axios.get(this.crmApiPath + 'contact/' + this.$store.state.auth.me.contact_id + '/company/show').then(company => {
        this.companyId = company.data.id;

        // Axios calls for real data
        const dashboard = axios.get(this.crmApiPath + 'reports/dashboard/' + this.companyId);

        axios.all([dashboard]).then(axios.spread((...responses) => {
          const dashboardResponse = responses[0];

          this.populateLabourAndExpensesData(dashboardResponse.data);
          this.populateWorkersOnSiteData(dashboardResponse.data);

          this.labourCostsTable = dashboardResponse.data.labour_costs;
          this.materialCostsTable = dashboardResponse.data.material_costs;
          this.expensesTable = dashboardResponse.data.expenses;

          this.complianceScore = Math.round(dashboardResponse.data.compliance_score * 100) / 100;
          this.complinaceLabel = Math.round(this.complianceScore * 100).toFixed(0) + '%';

          this.uncompliantWorkers = dashboardResponse.data.uncompliant_workers;

          this.loaded = true;

        })).catch(errors => {
          // react on errors.
        })
      });
    }
  },
  methods: {
    setFlags() {
      this.isPayroll = (this.crmType === 'payroll')
      this.isRecruitment = (this.crmType === 'recruitment');
      this.isPayrollEnabled = (this.isPayroll || this.isRecruitment && !this.$store.state.auth.me.recruitment);
      this.isRecruitmentEnabled = (this.isRecruitment && this.$store.state.auth.me.recruitment)
    },
    populateLabourAndExpensesData: function (data) {

      let labour = [];
      let expenses = [];
      let xAxis = [];

      let self = this;

      data.labour.forEach(function (slice) {
        labour.push(slice.amount);

        xAxis.push(Intl.DateTimeFormat('en').format(new Date(slice.date)));
      });

      data.costs.forEach(function (slice) {
        expenses.push(slice.amount);
      });

      this.labourAndExpensesSeries = [
        {
          name: 'Labour',
          data: labour
        }, {
          name: 'Expenses',
          data: expenses
        }
      ];

      this.labourAndExpensesOptions = {
        chart: {
          height: 350,
          type: 'area',
          toolbar: {
            show: false
          }
        },
        colors: ['#23c53e', '#3b90dc'],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              let currency = (new Intl.NumberFormat('en-GB', {style: 'currency', currency: 'GBP'}));

              return currency.format(value);
            }
          },
        },
        xaxis: {
          type: 'month',
          categories: xAxis
        },
      };
    },
    populateWorkersOnSiteData: function (data) {

      let workers = [];
      let xAxis = [];

      let self = this;

      data.workers_on_site.forEach(function (slice) {
        workers.push(slice.amount);

        xAxis.push(Intl.DateTimeFormat('en').format(new Date(slice.date)));
      });

      this.workersOnSiteSeries = [
        {
          name: 'Workers',
          data: workers
        }
      ];

      this.workersOnSiteOptions = {
        chart: {
          height: 350,
          type: 'area',
          toolbar: {
            show: false
          }
        },
        colors: ['#23c53e', '#3b90dc'],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          type: 'month',
          categories: xAxis
        },
      };
    },

    // test() {
    //   axios.get(this.crmApiPath + 'test').then(res => {console.log(res.data)})
    // }
  }
}
</script>
